import { DemoMemberIntroductionImg } from '@/constant/imgImport';
import {
  EMemberTabSectionKey,
  TEnterpriseProfileMemberTabSection,
} from '@/interfaces/enterprise-profile/member_tab.interface';

export const hashMemberSectionName = {
  [EMemberTabSectionKey.Introduction]: 'Giới thiệu',
  [EMemberTabSectionKey.MemberList]: 'Danh sách thành viên',
};

export const defaultMemberSection: TEnterpriseProfileMemberTabSection = [
  {
    sectionName: hashMemberSectionName[EMemberTabSectionKey.Introduction],
    sectionKey: EMemberTabSectionKey.Introduction,
    elements: {
      image: DemoMemberIntroductionImg,
    },
    isActive: true,
  },
  {
    sectionName: hashMemberSectionName[EMemberTabSectionKey.MemberList],
    sectionKey: EMemberTabSectionKey.MemberList,
    isActive: true,
  },
];
